module.exports = "/_next/static/images/8d591b560ac41ad12d3ff352928f1e91-custom-arrow.svg";